import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppSettingsService} from '../app/appSettings.service';
import {Grouping} from '../../model/filter/grouping.model';
import {GroupingListResult} from '../../model/filter/groupingListResult.model';


@Injectable()
export class FilterService {

  private url_root: string;
  private headersConfig: HttpHeaders;

  constructor(private http: HttpClient, private SettingsService: AppSettingsService) {
    this.url_root = `${SettingsService.getApiAddress()}/`;
    this.headersConfig = SettingsService.getHeadersConfig();
  }

  getBusinessProcess() {
      return this.http.get(`${this.url_root}WorkflowDimensions/ListBusinessProcesses`, { headers: this.headersConfig });
  }

  getUsers() {
    return this.http.get(`${this.url_root}WorkflowDimensions/ListUsers`, { headers: this.headersConfig });
  }

  getStates(businessProcessId: number) {
    return this.http.get(`${this.url_root}WorkflowDimensions/ListStates?businessProcessId=${businessProcessId}`,
      { headers: this.headersConfig });
  }

  getMetadataStructures() {
    return this.http.get(`${this.url_root}WorkflowDimensions/ListMetadataStructures`, { headers: this.headersConfig });
  }
}
